import { useState } from "react";
import { Plus, Trash, LinkSimple } from "@phosphor-icons/react";

export default function DocumentList({ documents = [], onChange, editable = true }) {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");

  const add = () => {
    if (!name.trim() || !url.trim()) return;
    onChange([...documents, { name: name.trim(), url: url.trim() }]);
    setName("");
    setUrl("");
  };

  const remove = (idx) => {
    const next = [...documents];
    next.splice(idx, 1);
    onChange(next);
  };

  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted mb-2">
        Documents ({documents.length})
      </div>
      <ul className="border border-canvas-line divide-y divide-canvas-line">
        {documents.length === 0 && (
          <li className="px-3 py-4 font-mono text-[11px] text-ink-subtle text-center">
            No documents attached.
          </li>
        )}
        {documents.map((d, idx) => (
          <li key={`${d.url}-${idx}`} className="px-3 py-2 flex items-center justify-between gap-2">
            <a
              href={d.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`doc-link-${idx}`}
              className="flex items-center gap-2 text-sm text-ink hover:underline min-w-0"
            >
              <LinkSimple size={13} weight="bold" className="shrink-0" />
              <span className="truncate">{d.name}</span>
            </a>
            {editable && (
              <button
                type="button"
                onClick={() => remove(idx)}
                data-testid={`doc-remove-${idx}`}
                className="p-1 hover:text-destructive"
                aria-label="Remove"
              >
                <Trash size={12} weight="bold" />
              </button>
            )}
          </li>
        ))}
      </ul>
      {editable && (
        <div className="mt-2 grid grid-cols-[1fr_2fr_auto] gap-2">
          <input
            data-testid="doc-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Doc name"
            className="px-2 py-2 bg-canvas border border-canvas-line text-sm focus:outline-none focus:border-ink"
          />
          <input
            data-testid="doc-url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://…"
            className="px-2 py-2 bg-canvas border border-canvas-line text-sm focus:outline-none focus:border-ink font-mono"
          />
          <button
            type="button"
            onClick={add}
            data-testid="doc-add"
            className="px-3 bg-ink text-white text-sm font-semibold hover:bg-brand flex items-center gap-1"
          >
            <Plus size={13} weight="bold" />
            Add
          </button>
        </div>
      )}
    </div>
  );
}
